package org.zq.astrock_ai.quant

internal object BacktestEngine {
    /**
     * 简单日频回测：全仓进出，忽略滑点手续费；仅用于研究示意。
     */
    fun run(
        strategy: QuantStrategy,
        bars: List<QuantBar>,
        params: Map<String, String> = emptyMap(),
    ): BacktestResult {
        val merged = strategy.info.defaultParams + params
        if (bars.size < 30) {
            return BacktestResult(
                strategyId = strategy.info.id,
                strategyName = strategy.info.name,
                lookbackDays = bars.size,
                trades = 0,
                winRate = 0.0,
                totalReturnPct = 0.0,
                maxDrawdownPct = 0.0,
                params = merged,
                note = "K 线样本不足（需至少约 30 根）",
            )
        }

        val sides = strategy.sides(bars, merged)
        var cash = 1.0
        var shares = 0.0
        var peak = 1.0
        var maxDd = 0.0
        var entryDate = ""
        var entryPrice = 0.0
        val trades = mutableListOf<BacktestTrade>()
        val equities = ArrayList<Double>(bars.size)

        for (i in bars.indices) {
            val bar = bars[i]
            when (sides[i]) {
                QuantSide.BUY -> if (shares == 0.0 && cash > 0) {
                    shares = cash / bar.close
                    cash = 0.0
                    entryDate = bar.date
                    entryPrice = bar.close
                }
                QuantSide.SELL -> if (shares > 0) {
                    val exitValue = shares * bar.close
                    val ret = (bar.close - entryPrice) / entryPrice * 100
                    trades += BacktestTrade(
                        entryDate = entryDate,
                        exitDate = bar.date,
                        entryPrice = entryPrice,
                        exitPrice = bar.close,
                        returnPct = ret,
                    )
                    cash = exitValue
                    shares = 0.0
                }
                QuantSide.HOLD -> Unit
            }
            val equity = cash + shares * bar.close
            equities += equity
            if (equity > peak) peak = equity
            val dd = if (peak > 0) (peak - equity) / peak * 100 else 0.0
            if (dd > maxDd) maxDd = dd
        }

        val lastClose = bars.last().close
        val finalEquity = cash + shares * lastClose
        val totalReturn = (finalEquity - 1.0) * 100
        val wins = trades.count { it.returnPct > 0 }
        val winRate = if (trades.isEmpty()) 0.0 else wins.toDouble() / trades.size

        return BacktestResult(
            strategyId = strategy.info.id,
            strategyName = strategy.info.name,
            lookbackDays = bars.size,
            trades = trades.size,
            winRate = winRate,
            totalReturnPct = totalReturn,
            maxDrawdownPct = maxDd,
            tradeDetails = trades.takeLast(8),
            equityCurve = downsampleEquity(equities, maxPoints = 48),
            params = merged,
            note = if (shares > 0) "期末仍持仓，按收盘价估值" else "已平仓结算",
        )
    }

    private fun downsampleEquity(values: List<Double>, maxPoints: Int): List<Double> {
        if (values.isEmpty()) return emptyList()
        if (values.size <= maxPoints) return values.map { (it * 10000).toInt() / 10000.0 }
        val step = (values.size - 1).toDouble() / (maxPoints - 1)
        return List(maxPoints) { i ->
            val idx = (i * step).toInt().coerceIn(0, values.lastIndex)
            (values[idx] * 10000).toInt() / 10000.0
        }
    }
}
